import React from 'react';
import PropTypes from 'prop-types';
import { timePeriodTypeDetails } from '../../../../../../../utility/types/TimePeriodTypes';

function TimePeriodTypeSelect({ timePeriodTypeId, onTimePeriodTypeChange, disabled }) {
  return (
    <select
      className="form-control form-control-sm my-1"
      aria-label="select time period"
      value={timePeriodTypeId}
      onChange={onTimePeriodTypeChange}
      disabled={disabled}
    >
      {Object.entries(timePeriodTypeDetails).map(([id, timePeriod], index) => (
        <option key={`time-period-code-${index}`} value={id}>
          {timePeriod.display}
        </option>
      ))}
    </select>
  );
}
TimePeriodTypeSelect.propTypes = {
  timePeriodTypeId: PropTypes.number.isRequired,
  onTimePeriodTypeChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
export default TimePeriodTypeSelect;
